import { LuCheck } from 'react-icons/lu'
import { Reveal } from '@/components/ui/Reveal'

/** Checklist cards used for "what's included" lists. */
export const IncludedGrid = ({ items }: { items: string[] }) => (
  <ul className="grid gap-4 sm:grid-cols-2">
    {items.map((item, index) => (
      <li key={item}>
        <Reveal delay={(index % 4) * 60} className="h-full">
          <div className="flex h-full items-start gap-4 rounded-2xl border border-base-200 bg-white p-5 transition-colors hover:border-green-300">
            <span
              aria-hidden="true"
              className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-50 text-green-700"
            >
              <LuCheck className="h-4 w-4" />
            </span>
            <span className="text-base leading-7 text-base-700">{item}</span>
          </div>
        </Reveal>
      </li>
    ))}
  </ul>
)
